import React from "react";
import { useTranslation, Trans } from "react-i18next";
import Button from "./Button";
import fca from '../img/fca.png'

function Footer({ titleKey }) {
  const { t } = useTranslation();

  return (
    <footer className="mt-[80px] xl:mt-[140px]">
      <div className="bg-[#0F0229] overflow-hidden">
        <div className="max-w-[1220px] mx-[20px] xl:mx-auto pt-[60px] xl:pt-[70px] pb-[26px]">
          {/* TOP ROW */}
          {titleKey && (
            <div className="flex flex-col gap-[30px] xl:flex-row xl:items-start xl:justify-between">
              <h2 className="text-white text-[32px] leading-[1.08] xl:text-[56px] font-[600] tracking-[-0.02em]">
                <Trans
                  i18nKey={titleKey}
                  components={{
                    span: <span className="text-[#79E2DD]" />,
                    br: <br />,
                  }}
                />
              </h2>

              <div className="mt-auto">
                <Button />
              </div>
            </div>
          )}

          {/* BOTTOM GRID */}
          <div className="mt-[54px] xl:mt-[60px] grid grid-cols-1 xl:grid-cols-4 gap-y-[18px] xl:gap-y-0 xl:gap-x-[30px]">
            {/* DISCLAIMER */}
            <div className="xl:col-span-2">
              <p className="text-[#FFFFFFB2] text-[14px] leading-[1.55] max-w-[520px]">
                {t("footer.1")}
              </p>
              <a href="/docs/fca.pdf" className="mt-[20px] xl:mt-[40px] flex items-center gap-[10px] hover:scale-[1.01] transition-all">
                <img src={fca} alt="" />
                <p className="text-white text-[14px] inter font-[500]">Regulation</p>
              </a>
              <a href="#" className="mt-[12px] flex items-center gap-[10px] hover:scale-[1.01] transition-all">
                <p className="text-[#65CDBF] text-[14px] inter font-[500]">More information</p>
                <svg className="flex-shrink-0" xmlns="http://www.w3.org/2000/svg" width="24" height="12" viewBox="0 0 24 12" fill="none">
                  <rect width="24" height="11.234" rx="1.02128" fill="#65CDBF"/>
                  <path d="M18.0529 5.79773C18.1526 5.69802 18.1526 5.53636 18.0529 5.43665L16.428 3.81181C16.3283 3.7121 16.1667 3.7121 16.067 3.81181C15.9672 3.91152 15.9672 4.07318 16.067 4.17288L17.5113 5.61719L16.067 7.06149C15.9672 7.1612 15.9672 7.32286 16.067 7.42257C16.1667 7.52227 16.3283 7.52227 16.428 7.42257L18.0529 5.79773ZM6.12766 5.61719V5.87251H17.8723V5.61719V5.36187H6.12766V5.61719Z" fill="black"/>
                </svg>
              </a>
            </div>

            {/* LINKS */}
            <div className="space-y-[6px] xl:space-y-[8px]">
              <a
                href="/docs/client.pdf"
                className="block text-[#FFFFFFB2] text-[14px] hover:text-white transition"
              >
                {t("footer.2")}
              </a>
              <a
                href="/docs/conflict.pdf"
                className="block text-[#FFFFFFB2] text-[14px] hover:text-white transition"
              >
                {t("footer.3")}
              </a>
              <a
                href="/docs/privacy.pdf"
                className="block text-[#FFFFFFB2] text-[14px] hover:text-white transition"
              >
                {t("footer.4")}
              </a>
              <a
                href="https://msi-commission.com/our-members/arvea/arvea.html"
                className="block text-[#FFFFFFB2] text-[14px] hover:text-white transition"
              >
                MSI
              </a>
              <a
                href="/docs/finma.pdf"
                className="block text-[#FFFFFFB2] text-[14px] hover:text-white transition"
              >
                FINMA
              </a>
              <a href="https://www.zefix.ch/en/search/entity/list/firm/1313371" className="block text-[#FFFFFFB2] text-[14px] hover:text-white transitio">
                Zefix
              </a>
            </div>

            {/* CONTACT */}
            <div className="space-y-[6px] xl:space-y-[8px]">
              <p className="text-[#FFFFFFB2] text-[14px]">
                <span className="text-white/70">{t("footer.5")}</span>{" "}
                Talacker 35, 8001 Zürich, Switzerland
              </p>
              <p className="text-[#FFFFFFB2] text-[14px]">
                <span className="text-white/70">{t("footer.6")}</span>{" "}
                support@{window.location.host}
              </p>
              <p className="text-[#FFFFFFB2] text-[14px]">
                <span className="text-white/70">{t("footer.7")}</span>{" "}
                +41415330674
              </p>
              <p className="text-[#FFFFFFB2] text-[14px]">
                CHE-202.930.922
              </p>
              
            </div>
          </div>

          {/* COPYRIGHT */}
          <div className="mt-[44px] xl:mt-[52px]">
            <p className="text-center text-[#FFFFFF80] text-[14px]">
              {t("footer.8")}
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
